import apiService from '../../conf/api.custom';

export default {
  fetch: (endpoint) => {
    return apiService.get(endpoint)
  }
};
